module.exports = __webpack_public_path__ + "img/cornerExample.bd3cc324.png";